import getSourceDomainFromHostname from './get-source-domain-from-hostname';

export const getSourceDomainFromHost = (host: string) => getSourceDomainFromHostname(host.split(':')[0].toLowerCase());
